/** Aviso activo que aún debe resaltar (no visto ni eliminado). */
export const isAlertPending = (alert) => {
  if (!alert || alert.resolved) return false;
  return !alert.seen;
};

export const hasPendingAlerts = (alerts = []) =>
  alerts.some(isAlertPending);
